import styled from "styled-components";

export const StyledList = styled.ul`
  width: 100%;
  align-self: flex-start;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  max-height: 335px;
  overflow-y: scroll;
`;
